import { Link, useNavigate } from 'react-router-dom';
import { PiArrowLeftBold, PiHouseBold } from 'react-icons/pi';

export default function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-zinc-950 px-6 text-white">

            {/* Faixa dourada topo */}
            <div
                className="absolute left-0 top-0 h-1 w-full"
                style={{ background: 'linear-gradient(90deg,#3D2D08 0%,#8B6914 20%,#C9A84C 50%,#F0D06A 65%,#C9A84C 80%,#8B6914 100%)' }}
            />

            {/* Glow de fundo */}
            <div
                className="pointer-events-none absolute inset-0 opacity-10"
                style={{ background: 'radial-gradient(ellipse 60% 40% at 50% 40%, #C9A84C 0%, transparent 70%)' }}
            />

            {/* Conteúdo */}
            <div className="relative z-10 flex max-w-2xl flex-col items-center text-center">

                {/* Logo */}
                <img
                    src="/img/design/Logo_Buckler_OffWhite.png"
                    alt="Buckler"
                    className="mb-12 h-10 object-contain opacity-70"
                    onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />

                {/* Número do erro */}
                <div className="relative mb-6 select-none">
                    <span
                        className="block font-black leading-none tracking-tighter"
                        style={{
                            fontSize: 'clamp(8rem, 22vw, 16rem)',
                            background: 'linear-gradient(180deg, #F0D06A 0%, #C9A84C 40%, #8B6914 80%, #3D2D08 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                            filter: 'drop-shadow(0 0 40px rgba(201,168,76,0.25))',
                        }}
                    >
                        404
                    </span>
                </div>

                {/* Linha decorativa */}
                <div
                    className="mb-8 h-px w-32"
                    style={{ background: 'linear-gradient(90deg, transparent, #C9A84C, transparent)' }}
                />

                {/* Título */}
                <h1 className="mb-3 text-3xl font-black leading-tight text-white md:text-4xl">
                    Página não encontrada
                </h1>

                {/* Descrição */}
                <p className="mb-10 max-w-md text-base leading-relaxed text-zinc-400">
                    A página que você está procurando não existe ou foi movida.
                    Verifique o endereço ou volte ao início.
                </p>

                {/* Ações */}
                <div className="flex flex-wrap items-center justify-center gap-3">
                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 rounded-xl border border-zinc-700 bg-zinc-800/60 px-5 py-3 text-sm font-bold text-zinc-300 transition hover:bg-zinc-700"
                    >
                        <PiArrowLeftBold className="size-4" />
                        Voltar
                    </button>

                    <Link
                        to="/"
                        className="flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-black transition"
                        style={{
                            background: 'linear-gradient(135deg, #8B6914 0%, #C9A84C 50%, #F0D06A 100%)',
                            color: '#1a1200',
                            boxShadow: '0 4px 20px rgba(201,168,76,0.3)',
                        }}
                    >
                        <PiHouseBold className="size-4" />
                        Ir para o início
                    </Link>
                </div>
            </div>

            {/* Faixa dourada rodapé */}
            <div
                className="absolute bottom-0 left-0 h-px w-full"
                style={{ background: 'linear-gradient(90deg, transparent, #C9A84C40, transparent)' }}
            />
        </div>
    );
}
